import { Component, OnInit } from '@angular/core';
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
import { Router } from '@angular/router';

@Component({
  templateUrl: 'dashboardReporte.component.html'
})
export class DashboardReporteComponent implements OnInit {

  radioModel: string = 'Month';
  usuario:string;
  local:string;




  constructor(private ruter: Router){
  }
  ngOnInit(): void {
   // throw new Error('Method not implemented.');
  }
  
  reportLocales(){
    if (localStorage.getItem('rol')=='MaxiPan'){
      this.ruter.navigate(['ventas-local']);
    }
    if (localStorage.getItem('rol')=='local'){
      this.ruter.navigate(['ventas-local']);
    }
    if (localStorage.getItem('rol')=='Administrador CF'){
      this.ruter.navigate(['ventas-local']);
    }
    if (localStorage.getItem('rol')=='Administrador CF'){
      this.ruter.navigate(['rankig-local']);
    }
  

  }

  reportMetas(){
    if (localStorage.getItem('rol')=='MaxiPan'){
      this.ruter.navigate(['meta-reporte']);
    }
    if (localStorage.getItem('rol')=='local'){
      this.ruter.navigate(['meta-reporte']);
    }
    if (localStorage.getItem('rol')=='Administrador CF'){
      this.ruter.navigate(['meta-reporte']);
    }
    if (localStorage.getItem('rol')=='Administrador CF'){
      this.ruter.navigate(['meta-reporte']);
    }
  

  }

  

  reportRankig(){
    if (localStorage.getItem('rol')=='MaxiPan'){
      this.ruter.navigate(['rankig-local']);
    }
    if (localStorage.getItem('rol')=='local'){
      this.ruter.navigate(['rankig-local']);
    }
    if (localStorage.getItem('rol')=='Administrador CF'){
      this.ruter.navigate(['rankig-local']);
    }
    if (localStorage.getItem('rol')=='Administrador CF'){
      this.ruter.navigate(['rankig-local']);
    }
  

  }
  reportCrecimiento(){
    if (localStorage.getItem('rol')=='MaxiPan'){
      this.ruter.navigate(['reporte-crecimiento']);
    }
    if (localStorage.getItem('rol')=='local'){
      this.ruter.navigate(['reporte-crecimiento']);
    }
    if (localStorage.getItem('rol')=='Administrador CF'){
      this.ruter.navigate(['reporte-crecimiento']);
    }
    if (localStorage.getItem('rol')=='Administrador CF'){
      this.ruter.navigate(['reporte-crecimiento']);
    }
  

  }
  reportDevolucion(){
    if (localStorage.getItem('rol')=='MaxiPan'){
      this.ruter.navigate(['devolucion-local']);
    }
    if (localStorage.getItem('rol')=='local'){
      this.ruter.navigate(['devolucion-local']);
    }
    if (localStorage.getItem('rol')=='Administrador CF'){
      this.ruter.navigate(['devolucion-local']);
    }

    if (localStorage.getItem('rol')=='Administrador CF'){
      this.ruter.navigate(['devolucion-local']);
    }
  

  }
}
